import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface TCPParams {
  category?: string;
  utmSource?: string;
  utmMedium?: string;
  jarvisId?: string;
  anonymousId?: string;
  sessionId?: string;
  lat?: string;
  long?: string;
  city?: string;
  pincode?: string;
  authCode?: string;
  codeVerifier?: string;
  source?: string;
}

interface TCPParamsStore {
  params: TCPParams;
  setParams: (params: Partial<TCPParams>) => void;
  clearParams: () => void;
}

export const useTCPParams = create<TCPParamsStore>()(
  persist(
    (set) => ({
      params: {},
      setParams: (newParams) => set((state) => ({ 
        params: { ...state.params, ...newParams } 
      })),
      clearParams: () => set({ params: {} }),
    }),
    {
      name: 'tcp-params-storage',
    }
  )
);
